import apiClient from '../apiClient';
import type { ApiResponse } from '@/types';

export const uploadProductImage = async (
  file: File,
  machineId: string,
  slotNumber: number
): Promise<string> => {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('machineId', machineId);
  formData.append('slotNumber', String(slotNumber));

  const { data } = await apiClient.post<ApiResponse<{ imageUrl: string }>>(
    '/upload/product-image',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data.data.imageUrl;
};
